let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3nwDR")).then(() => parcelRequire('9RwzH'));